





















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { Maybe } from '@/types/general'

const zxcvbn = () => import('zxcvbn')

@Component({ name: 'v-password-breakdown' })
export default class VPasswordBreakdown extends Vue {
    breakdown: any = null

    @Prop({ type: String, required: true })
    password!: string

    @Prop({ type: Boolean, default: false })
    expanded!: boolean

    /**
     * Whether to shift the labels across to make room
     * for input commit/revert controls
     */
    @Prop({ type: Boolean, default: false })
    moveForControls!: boolean

    @Watch('password', { immediate: true })
    updatePassword(password: string): void {
        if (password) {
            zxcvbn().then(({ default: check }) => {
                this.breakdown = check(password)
            })
        }
    }

    get crackTimeMin(): string {
        if (!this.breakdown) {
            return 'checking...'
        }
        const { crack_times_display: display } = this.breakdown
        return display.offline_slow_hashing_1e4_per_second
    }

    get crackTimeMax(): string {
        if (!this.breakdown) {
            return 'checking...'
        }
        const { crack_times_display: display } = this.breakdown
        return display.online_no_throttling_10_per_second
    }

    get guesses(): string {
        if (!this.breakdown) {
            return 'checking...'
        }
        return this.breakdown.guesses.toLocaleString()
    }

    get score(): number {
        if (!this.breakdown) {
            return 0
        }
        return this.breakdown.score
    }

    get strength(): string {
        if (!this.breakdown) {
            return 'checking...'
        }
        return [
            'very weak',
            'weak',
            'okay',
            'strong',
            'very strong'
        ][this.score]
    }

    get feedback(): string[] {
        if (!this.breakdown) {
            return []
        }
        return this.breakdown.feedback.suggestions
    }

    get warning(): Maybe<string> {
        if (!this.breakdown) {
            return undefined
        }
        return this.breakdown.feedback.warning
    }
}
